import {
  CreateJobCatalogNodeAttributeDocument,
  CreateJobCatalogNodeAttributeMutation,
  NodePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import { getChildNodeType } from 'modules/job_catalog/lib/nodesUtils'

const useAddJobCatalogNodeAttribute = () => {
  const [mutate, { loading }] = useMutation(CreateJobCatalogNodeAttributeDocument, {
    extractorFn: (data: CreateJobCatalogNodeAttributeMutation) =>
      data.jobCatalogMutations.createJobcatalogNodeAttribute,
  })

  const addAttribute = (
    attributeType: string,
    companyId: string,
    nodeUuid: string,
    valueJson: string,
    attributeId?: string,
    inheritanceType?: string
  ) => {
    const childType = getChildNodeType(nodeUuid)

    return mutate({
      variables: {
        attributeId,
        attributeType,
        companyId,
        nodeUuid,
        valueJson,
        inheritanceType,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            nodeUuid: nodeUuid,
            childType,
          },
        },
      ],
    })
  }

  return { addAttribute, loading }
}

export default useAddJobCatalogNodeAttribute
